var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgCheckedIcon = function SvgCheckedIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 3.58033 3.58033 0 8 0C12.4197 0 16 3.58033 16 8C16 12.4197 12.4197 16 8 16C3.58033 16 0 12.4197 0 8ZM4.11816 7.88197L7.37062 11.1213L12.4723 6.03279L11.5411 5.10164L7.37062 9.27213L5.04931 6.95082L4.11816 7.88197Z",
    fill: "#20D370"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckedIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDhDMCAzLjU4MDMzIDMuNTgwMzMgMCA4IDBDMTIuNDE5NyAwIDE2IDMuNTgwMzMgMTYgOEMxNiAxMi40MTk3IDEyLjQxOTcgMTYgOCAxNkMzLjU4MDMzIDE2IDAgMTIuNDE5NyAwIDhaTTQuMTE4MTYgNy44ODE5N0w3LjM3MDYyIDExLjEyMTNMMTIuNDcyMyA2LjAzMjc5TDExLjU0MTEgNS4xMDE2NEw3LjM3MDYyIDkuMjcyMTNMNS4wNDkzMSA2Ljk1MDgyTDQuMTE4MTYgNy44ODE5N1oiIGZpbGw9IiMyMEQzNzAiLz4KPC9zdmc+Cg==";